import { useEffect, useMemo, useState } from 'react';
import { Pagination, Spin } from 'antd';
import { video } from '../../services/api';
import EzvizPlayer from '../../components/EzvizPlayer';

const PAGE_SIZE = 4;

export default function StationVideoGrid({ spaceId }) {
  const [cameras, setCameras] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [page, setPage] = useState(1);

  useEffect(() => {
    let cancelled = false;
    setLoading(true);
    setError(null);
    setPage(1);
    video.list().then((res) => {
      if (cancelled) return;
      setCameras((res.data || []).filter(camera => camera.space_id === spaceId));
    }).catch((err) => {
      if (!cancelled) setError(err.response?.data?.message || err.message || '摄像头档案加载失败');
    }).finally(() => {
      if (!cancelled) setLoading(false);
    });
    return () => { cancelled = true; };
  }, [spaceId]);

  const currentCameras = useMemo(
    () => cameras.slice((page - 1) * PAGE_SIZE, page * PAGE_SIZE),
    [cameras, page]
  );

  if (loading) return <div className="bs-video-state"><Spin /></div>;
  if (error) return <div className="bs-video-state">{error}</div>;
  if (cameras.length === 0) return <div className="bs-video-state">该站点暂无摄像头档案</div>;

  return (
    <div className="bs-video-panel">
      <div className="bs-video-grid">
        {currentCameras.map(camera => (
          <div className="bs-video-cell" key={camera.id}>
            <EzvizPlayer camera={camera} compact />
            <div className="bs-video-cell-title">{camera.name}</div>
          </div>
        ))}
      </div>
      <div className="bs-video-pagination">
        <span>共 {cameras.length} 路 · 每屏 {PAGE_SIZE} 路 · 子码流按需取流</span>
        <Pagination
          simple current={page} pageSize={PAGE_SIZE} total={cameras.length}
          onChange={setPage} size="small" showSizeChanger={false}
        />
      </div>
    </div>
  );
}
